import React from 'react';
import "./logo.css";
import logo from '../Assets/2xsmartlogo1.png';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

function Logo() {
  const navigate = useNavigate();

  const click = () => {
    const username = Cookies.get('path');
    navigate(username);
  }
  return (
    <div className='logo df jc ac'>
      <img onClick={click} src={logo} alt='logo' />
    </div>
  )
}
export default Logo;